module.exports = __WEBPACK_EXTERNAL_MODULE_25__;


//////////////////
// WEBPACK FOOTER
// external {"root":"@material/icon-toggle/dist/mdc.iconToggle","commonjs2":"@material/icon-toggle/dist/mdc.iconToggle","commonjs":"@material/icon-toggle/dist/mdc.iconToggle","amd":"@material/icon-toggle/dist/mdc.iconToggle","umd":"@material/icon-toggle/dist/mdc.iconToggle"}
// module id = 25
// module chunks = 0